import { useQuery } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { ChannelsListResponse } from '../types/backend';

export type SearchChannelsQuery = {
  search: string;
  limit?: number;
  offset?: number;
};

const searchChannels = async (
  params: SearchChannelsQuery
): Promise<ChannelsListResponse> => {
  const { search, limit = 50, offset = 0 } = params;

  const queryParams = new URLSearchParams({
    search,
    limit: String(limit),
    offset: String(offset),
  });

  return axios.get(`${MESSAGING_API_BASE}/channels/search?${queryParams}`);
};

type QueryFnType = typeof searchChannels;

type UseSearchChannelsOptions = {
  search: string;
  limit?: number;
  offset?: number;
  config?: QueryConfig<QueryFnType>;
};

export const useSearchChannels = ({
  search,
  limit,
  offset,
  config,
}: UseSearchChannelsOptions) => {
  return useQuery({
    queryKey: [...messagingQueryKeys.channelsSearch(search, limit, offset)],
    queryFn: () => searchChannels({ search, limit, offset }),
    staleTime: 30000, // Cache search results for 30 seconds
    enabled: search.length > 0,
    ...config,
  });
};
